import styled, { css } from 'styled-components'
import {
  AI_GRADIENT,
  AI_DARK_GRAY,
  AI_STEP_BORDER,
  AI_STEP_CONNECTOR,
} from './aiEvaluationTokens'

export type StepStatus = 'finish' | 'process' | 'wait'

export const StepperRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`

export const StepsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 155px;
  justify-content: flex-start;
`

export const StepRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StepCircle = styled.span<{ $status: StepStatus }>`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px;

  ${({ $status }) =>
    $status === 'finish' &&
    css`
      background: linear-gradient(
        90deg,
        rgba(255, 102, 161, 0.08) 18.3%,
        rgba(255, 93, 44, 0.08) 100%
      );

      svg {
        width: 14px !important;
        height: 14px !important;

        path {
          fill: url(#rankmiAiGradient);
        }
      }
    `}

  ${({ $status }) =>
    $status === 'process' &&
    css`
      background: ${AI_GRADIENT};
      color: #ffffff;
      font-weight: 700;
    `}

  ${({ $status }) =>
    $status === 'wait' &&
    css`
      background: #ffffff;
      border: 1px solid ${AI_STEP_BORDER};
      color: ${AI_DARK_GRAY};
      font-weight: 400;
    `}
`

export const StepLabel = styled.p<{ $active?: boolean }>`
  margin: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${AI_DARK_GRAY};
  font-weight: ${({ $active }) => ($active ? 700 : 400)};
`

export const StepConnector = styled.div`
  width: 32px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 0;
  box-sizing: content-box;

  &::before {
    content: '';
    width: 1px;
    height: 100%;
    border-radius: 0.5px;
    background: ${AI_STEP_CONNECTOR};
  }
`

export const LoaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
  padding: 24px;
  box-sizing: border-box;
`

export const LoaderBox = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    90deg,
    rgba(255, 93, 44, 0.16) 12.5%,
    rgba(255, 193, 63, 0.16) 100%
  );
`

export const LoaderImage = styled.img`
  width: 46px;
  height: 46px;
  object-fit: contain;
`
